import React from "react";
import PageHeader from "../components/PageHeader";

export default function PocsoDocuments() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "POCSO Act", link: "/pocso-act" },
    { label: "Documents / Guidelines", active: true },
  ];

  const documents = [
    {
      title: "MODEL GUIDELINES WITH RESPECT TO SUPPORT PERSONS UNDER SECTION 39 OF POCSO ACT - 2012",
      file: "Details 332.26 KB",
      date: "21-08-24",
      link: "#",
    },
    {
      title: "AN EASY GUIDE FOR IMPLEMENTATION OF THE POCSO ACT,2012",
      file: "Details 5.17 MB",
      date: "01-07-22",
      link: "#",
    },
    {
      title: "A GUIDE FOR DISTRICT ADMINISTRATION FOR IMPLIMENTATION OF JUVENILE JUSTICE ACT 2015 AND POCSO ACT 2012",
      file: "Details 5.17 MB",
      date: "11-07-22",
      link: "#",
    },
    {
      title: "CHILD VICTIMS OF CYBER CRIME- LEGAL TOOL KIT",
      file: "Details 3.20 MB",
      date: "11-07-22",
      link: "#",
    },
    {
      title: "DO'S AND DONT'S FOR STAY SAFE ON INTERNET",
      file: "Details 192.42 KB",
      date: "11-07-22",
      link: "#",
    },
    {
      title: "USER HANDBOOK ON THE POCSO ACT 2012",
      file: "Details 5.77 MB",
      date: "11-07-22",
      link: "#",
    },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader
        title="POCSO Documents / Guidelines"
        breadcrumbs={breadcrumbs}
      />

      {/* Timeline Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-primary fw-bold mb-5 text-center">
            POCSO Guidelines / Documents (NCPCR, Govt. of India)
          </h2>

          <div className="position-relative">
            {/* Center line */}
            <div
              className="position-absolute top-0 start-50 translate-middle-x bg-primary"
              style={{ width: "4px", height: "100%", borderRadius: "2px" }}
            ></div>

            {/* Timeline items */}
            <div className="timeline position-relative">
              {documents.map((doc, index) => (
                <div
                  key={index}
                  className={`row g-0 mb-5 align-items-center ${
                    index % 2 === 0 ? "flex-row-reverse" : ""
                  }`}
                >
                  <div className="col-md-6 d-flex justify-content-center">
                    <div className="card shadow-sm p-4 rounded-4 border-0 timeline-card">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <span className="badge bg-primary rounded-pill">
                          {index + 1}
                        </span>
                        <small className="text-muted">{doc.date}</small>
                      </div>
                      <h5 className="text-primary fw-bold mb-3">{doc.title}</h5>
                      <p className="text-secondary mb-3">{doc.file}</p>
                      <a
                        href={doc.link}
                        className="btn btn-outline-primary rounded-pill"
                      >
                        View
                      </a>
                    </div>
                  </div>
                  <div className="col-md-6"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
